module.exports = __webpack_public_path__ + "assets/Honeywell_Logo_RGB_Red-d429a8.png";


//////////////////
// WEBPACK FOOTER
// ./Content/images/Honeywell_Logo_RGB_Red.png
// module id = 360
// module chunks = 2